export class RightraError extends Error {
  constructor(code, message, status) {
    super(message || "Something went wrong.");
    this.name = "RightraError";
    this.code = code || "UNKNOWN";
    this.status = status || 0;
  }
}

export function errorFromResponse(status, body) {
  if (body && typeof body === "object" && body.code && body.message) {
    return new RightraError(body.code, body.message, status);
  }
  if (status === 0) {
    return new RightraError("NETWORK", "Connection problem. Check your internet and try again.", 0);
  }
  if (status === 401) return new RightraError("NOT_AUTHENTICATED", "Invalid or missing API key.", status);
  if (status === 403) return new RightraError("NOT_AUTHORIZED", "This key is not allowed to do that.", status);
  if (status === 404) return new RightraError("NOT_FOUND", "We could not find that.", status);
  if (status === 409) return new RightraError("CONFLICT", "That action conflicts with the current state.", status);
  if (status === 429) return new RightraError("RATE_LIMIT", "Too many requests. Please slow down.", status);
  if (status >= 500) return new RightraError("SERVER", "Something went wrong on our side.", status);
  return new RightraError("UNKNOWN", "Something went wrong.", status);
}